export default {
  INIT: 'REPORTJOB/INIT',
  UPDATE_JOB_DATA: 'REPORTJOB/UPDATE_JOB_DATA',
  UPDATE_JOB_META: 'REPORTJOB/UPDATE_JOB_META',
  UPDATE_JOB_PARAMS: 'REPORTJOB/UPDATE_JOB_PARAMS',
}
